import { render, staticRenderFns } from "./insertVariable.vue?vue&type=template&id=16a9b840&scoped=true"
import script from "./insertVariable.vue?vue&type=script&lang=js"
export * from "./insertVariable.vue?vue&type=script&lang=js"
import style0 from "./insertVariable.vue?vue&type=style&index=0&id=16a9b840&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9b840",
  null
  
)

export default component.exports